import React from "react";
import { ShieldCheck } from "lucide-react";

const stages = [
  { title: "Supplier Selection", desc: "Vetting sourcing partners across origin belts." },
  { title: "Product Specification", desc: "Aligning grade, moisture, broken %, packaging to buyer needs." },
  { title: "Sample Approval", desc: "Pre-shipment samples aligned to buyer-approved reference." },
  { title: "Quality Inspection", desc: "Verification of specifications during processing." },
  { title: "Packaging Verification", desc: "Weight, seal integrity and labeling checks." },
  { title: "Pre-Shipment Coordination", desc: "Loading supervision and container documentation." },
  { title: "Documentation", desc: "Export documents prepared per destination requirements." },
];

const Quality = () => (
  <div>
    <section className="bg-[#004225] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[11px] font-eyebrow text-[#D4AF37]"><span className="gold-line mr-3" />Quality Assurance</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl">Quality at Every Stage</h1>
        <p className="mt-3 max-w-2xl text-white/80">A structured quality process aligned to buyer specifications. Third-party inspections available on request through SGS / Intertek / Bureau Veritas.</p>
      </div>
    </section>
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {stages.map((s, i) => (
          <div key={s.title} className="bg-white border border-[#004225]/10 rounded-sm p-6 card-elevate">
            <div className="text-[10px] font-eyebrow text-[#D4AF37]">{String(i + 1).padStart(2, "0")}</div>
            <ShieldCheck className="h-5 w-5 text-[#004225] mt-2" />
            <div className="mt-2 font-display text-lg text-[#004225]">{s.title}</div>
            <p className="mt-2 text-[13px] text-[#171717]/75">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default Quality;
